import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DpFormModule, DpHeaderModule, DpPaginationModule, DpSearchModule, DpTableModule } from '@docpath/webcomponents';
import { TranslateModule } from '@ngx-translate/core';

import { EnginesHeaderComponent } from './components/header/engines-header.component';
import { EnginesTableComponent } from './components/table/engines.table.component';
import { EnginesComponent } from './engines.component';

@NgModule({
    declarations: [
        EnginesComponent,
        EnginesHeaderComponent,
        EnginesTableComponent
    ],
    imports: [
        CommonModule,
        DpFormModule,
        TranslateModule,
        DpHeaderModule,
        DpSearchModule,
        DpTableModule,
        DpPaginationModule
    ],
    providers: [

    ]
})
export class EnginesModule { }


